module.exports = __webpack_public_path__ + "img/help29.bd207200.png";